import * as React from 'react';
import {widget} from '../../charting_library/charting_library.min';
import utils from "../../common/utils";
import {BASE_URL, PREFIX_FRONT_URL} from "../../consts";
import { clientTz } from 'timezone-select-js';

function getLanguageFromURL() {
	const regex = new RegExp('[\\?&]lang=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

const DEFAULT_INTERVAL = '15';

export class TVChartContainer extends React.PureComponent {
	static defaultProps = {
		symbol: 'ETH:BTC',
		interval: DEFAULT_INTERVAL,
		containerId: 'tv_chart_container',
		datafeedUrl: `${BASE_URL}/v1/cryptotrading/chart`,
		libraryPath: `/charting_library/`,
		// chartsStorageUrl: 'https://saveload.tradingview.com',
		// chartsStorageApiVersion: '1.1',
		// clientId: 'tradingview.com',
		// userId: 'public_user_id',
		fullscreen: false,
		// autosize: true,
		overrides: {
			'mainSeriesProperties.candleStyle.upColor': 'rgba(22,177,87,0.7)',
			'mainSeriesProperties.candleStyle.downColor': 'rgba(240, 83, 89, 0.7)',
			'mainSeriesProperties.candleStyle.borderUpColor': 'rgba(22, 177, 87, 0.7)',
			'mainSeriesProperties.candleStyle.borderDownColor': 'rgba(240, 83, 89, 0.7)',
			'mainSeriesProperties.candleStyle.wickUpColor': 'rgba(22, 177, 87, 0.7)',
			'mainSeriesProperties.candleStyle.wickDownColor': 'rgba(240, 83, 89, 0.7)',
			'mainSeriesProperties.candleStyle.barColorsOnPrevClose': false,
			'mainSeriesProperties.minTick': 'default',
		},
		theme: 'dark',
		timezone: clientTz(),
		// studiesOverrides: {},
	};

	tvWidget = null;

	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps.symbol !== this.props.symbol) {
			// console.log("=== resetCacheTimeTVChart ===");
			utils.resetCacheTimeTVChart();

			if (!!this.tvWidget && !!this.tvWidget._innerWindow() && !!this.tvWidget._innerWindow().tradingViewApi) {
				this.tvWidget.setSymbol(nextProps.symbol, DEFAULT_INTERVAL, () => {});
				if (!!this.tvWidget.chart(0)) {
					this.tvWidget.chart(0).resetData();
				}
			}
			// console.log("=== reset chart ===");
		}
	}

	componentDidMount() {
		const self = this;
		window.Datafeeds.calculateHistoryDepth = function (resolution, resolutionBack, intervalBack) {
			console.log(resolution, ': resolution src/components/exchange/TVChart.js:61');
			if (resolution === "1D") {
				return {
					resolutionBack: 'M',
					intervalBack: 6
				};
			}
			if (resolution === "5") {
				return {
					resolutionBack: 'D',
					intervalBack: 3
				};
			}
			if (resolution === "15") {
				return {
					resolutionBack: 'D',
					intervalBack: 7
				};
			}
			if (resolution === "30") {
				return {
					resolutionBack: 'D',
					intervalBack: 14
				};
			}
			if (resolution === "60") {
				return {
					resolutionBack: 'M',
					intervalBack: 1
				};
			}
		}

		const widgetOptions = {
			symbol: this.props.symbol,
			// BEWARE: no trailing slash is expected in feed URL
			datafeed: new window.Datafeeds.UDFCompatibleDatafeed(this.props.datafeedUrl, 5 * 1000),
			interval: DEFAULT_INTERVAL,
			container_id: this.props.containerId,
			library_path: this.props.libraryPath,

			locale: getLanguageFromURL() || 'en',
			disabled_features: ['use_localstorage_for_settings'],
			// enabled_features: ['study_templates'],
			// charts_storage_url: this.props.chartsStorageUrl,
			// charts_storage_api_version: this.props.chartsStorageApiVersion,
			// client_id: this.props.clientId,
			// user_id: this.props.userId,
			fullscreen: this.props.fullscreen,
			autosize: this.props.autosize,
			overrides: this.props.overrides,
			height: '100%',
			width: '100%',
			theme: this.props.theme,
			timezone: this.props.timezone 
		};


		const tvWidget = new widget(widgetOptions);
		this.tvWidget = tvWidget;

		
		tvWidget.onChartReady(() => {
			self.tvWidget.chart(0).createStudy('Moving Average', false, false, [20], null, {
				'Plot.linewidth': 1.3,
				'Plot.color': '#0090eb'
			});
			self.tvWidget.chart(0).createStudy('Moving Average', false, false, [40], null, {
				'Plot.linewidth': 1.3,
				'Plot.color': '#000000'
			});
			self.tvWidget.chart(0).createStudy('Volume', false, false, [20]);
			utils.resetCacheTimeTVChart();
			// tvWidget.headerReady().then(() => {
			// 	const button = tvWidget.createButton();
			// 	button.setAttribute('title', 'Click to show a notification popup');
			// 	button.classList.add('apply-common-tooltip');
			// 	button.addEventListener('click', () => tvWidget.showNoticeDialog({
			// 		title: 'Notification',
			// 		body: 'TradingView Charting Library API works correctly',
			// 		callback: () => {
			// 			console.log('Noticed!');
			// 		},
			// 	}));
			//
			// 	button.innerHTML = 'Check API';
			// });


			// window.tw = tvWidget;
			if (!!tvWidget.chart(0)) {
				tvWidget.chart(0).onIntervalChanged().subscribe(null, (interval, timeFrameParam) => {
					utils.resetCacheTimeTVChart();
					// self.props.onChangeInterval(interval);
					// self.tvWidget.setSymbol(self.props.symbol, interval, () => {});
				});
			}
		});
	}

	componentWillUnmount() {
		if (this.tvWidget !== null) {
			this.tvWidget.remove();
			this.tvWidget = null;
		}
	}

	render() {
		return (
			<div
				id={this.props.containerId}
				className={'TVChartContainer'}
			/>
		);
	}
}
